/**
 * Converts a Wasabi URL to our local image endpoint URL
 * @param {string} wasabiUrl - The original Wasabi URL
 * @param {string} imageId - The ID of the image in our database
 * @param {boolean} isPublic - Whether to use the public endpoint
 * @returns {string} The local image URL
 */
export const getLocalImageUrl = (wasabiUrl, imageId, isPublic = false) => {
  if (!wasabiUrl || !imageId) return '';
  
  const endpoint = isPublic ? 'public' : 'ai';
  return `/api/images/${endpoint}/${imageId}`;
};

/**
 * Converts a Wasabi URL to our local video endpoint URL
 * @param {string} wasabiUrl - The original Wasabi URL
 * @param {string} videoId - The ID of the video in our database
 * @param {boolean} isPublic - Whether to use the public endpoint
 * @returns {string} The local video URL
 */
export const getLocalVideoUrl = (wasabiUrl, videoId, isPublic = false) => {
  if (!wasabiUrl || !videoId) return '';
  
  const endpoint = isPublic ? 'public' : 'ai';
  return `/api/videos/${endpoint}/${videoId}`;
};

/**
 * Extracts the media ID from a URL
 * @param {string} url - The media URL
 * @returns {string|null} The media ID or null if not found
 */
export const extractMediaIdFromUrl = (url) => {
  if (!url) return null;
  
  const parts = url.split('/');
  return parts[parts.length - 1];
};

/**
 * Determines if a URL is for an image or video
 * @param {string} url - The URL to check
 * @returns {string} 'image', 'video', or 'unknown'
 */
export const getMediaType = (url) => {
  if (!url) return 'unknown';
  
  if (url.includes('/images/')) {
    return 'image';
  } else if (url.includes('/videos/')) {
    return 'video';
  }
  
  // Check file extension
  const extension = url.split('.').pop().toLowerCase();
  if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'].includes(extension)) {
    return 'image';
  } else if (['mp4', 'webm', 'ogg', 'mov'].includes(extension)) {
    return 'video';
  }
  
  return 'unknown';
}; 